import { useMutation, useQuery, useQueryClient } from 'react-query';
import { notification } from 'antd';
import {
  createMatrixWhatsappSettings,
  deleteMatrixWhatsappSettings,
  getByIdMatrixWhatsappSettings,
  getMatrixWhatsappSettings,
  updateMatrixWhatsappSettings,
} from './MatrixWhatsappSettings.service';
import notificationError from '@/utils/functions/notificationError';

export function useMatrixWhatsappSettings() {
  const query = useQuery(['matrix-whatsapp'], getMatrixWhatsappSettings, {
    onError(error) {
      notificationError(error);
    },
  });

  return query;
}

export function useMatrixWhatsappSettingsCreate() {
  const queryClient = useQueryClient();

  const query = useMutation(createMatrixWhatsappSettings, {
    async onSuccess() {
      await queryClient.invalidateQueries(['matrix-whatsapp']);

      notification.success({
        message: 'Sucesso',
        description: 'Template whatsapp criado com sucesso!',
      });
    },
    onError(error) {
      notificationError(error);
    },
  });

  return query;
}

export function useMatrixWhatsappSettingsById() {
  const query = useMutation((id: number) => getByIdMatrixWhatsappSettings(id), {
    onError(error) {
      notificationError(error);
    },
  });

  return query;
}

export function useMatrixWhatsappSettingsUpdate() {
  const queryClient = useQueryClient();

  const query = useMutation(updateMatrixWhatsappSettings, {
    async onSuccess() {
      await queryClient.invalidateQueries(['matrix-whatsapp']);

      notification.success({
        message: 'Sucesso',
        description: 'Template whatsapp salvo com sucesso!',
      });
    },
    onError(error) {
      notificationError(error);
    },
  });

  return query;
}

export function useMatrixWhatsappSettingsDelete() {
  const queryClient = useQueryClient();

  const query = useMutation(deleteMatrixWhatsappSettings, {
    async onSuccess() {
      await queryClient.invalidateQueries(['matrix-whatsapp']);

      notification.success({
        message: 'Sucesso',
        description: 'Template whatsapp deletado com sucesso!',
      });
    },
    onError(error) {
      notificationError(error);
    },
  });

  return query;
}
